export default __webpack_public_path__ + "static/Bg6-ba524fdf4e95b68a6d44e1da309c71a4.png";